import React, { FC, ReactNode, RefObject } from 'react';
import { Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import lodash from 'lodash';

type MultiColumnViewProps = {
  title?: string | null;
  items: ReactNode[];
  columns?: number;
  forwardedRef?: RefObject<HTMLDivElement>;
  rowGap?: number;
};

const MultiColumnView: FC<MultiColumnViewProps> = ({
  title,
  items,
  columns = 1,
  forwardedRef,
  rowGap = 2
}) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  columns = isSm ? 1 : columns;
  const chunks = lodash.chunk(items, Math.ceil(items.length / columns));

  const gridColumns = 12 / chunks.length;
  return (
    <Stack sx={{ width: '100%' }} ref={forwardedRef} mb={2}>
      {title && (
        <Typography variant="h4" color="primary.main" gutterBottom>
          {title}
        </Typography>
      )}
      <Grid container columnGap={3} flexWrap="nowrap">
        {chunks.map((chunk, index) => (
          <Grid item key={index} xs={gridColumns}>
            <Stack alignItems="start" rowGap={rowGap}>
              {chunk}
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default MultiColumnView;
